import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const NotificationPanelStyle = styled.div`
  position: absolute;
  width: 100%;
  height: 53px;
  left:0;
  padding: 7px 10px 7px 10px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);
  background-color: ${props => props.bgColor || "#f3a101"};
  text-align:center;
  .notification-panel-text {
    position:relative;
    top: 0;
    color: ${props => props.textColor || "#464646"};
    font-size: 12px;
    text-align: center;
    display: inline-grid;
  }
  .notification-panel-link {
    
    position:relative;
    left: 0px;
    font-weight: 500;
    color: #464646;
  }
  @media (min-width: 800px) {

    height: 36px;
    padding: 0;
    top:100px;
    .notification-panel-text {
      display:block;
      font-size: 16px;
      top: 6px;
    }
    .notification-panel-link {
      left: 10px;
    }

  }
`;

const NotificationPanel = (props) => {
  return (
    <NotificationPanelStyle bgColor={props.bgColor} textColor={props.textColor}>
      <span className="notification-panel-text">
        {props.notificationText}
        {props.notificationLinkText ? 
          <Link 
            className="notification-panel-link" 
            to={props.notificationLinkUrl}>
            {props.notificationLinkText}
          </Link> 
        : null}
      </span>
    </NotificationPanelStyle>
  );
}

export default NotificationPanel;


// WEBPACK FOOTER //
// ./src/components/UI/NotificationPanel/NotificationPanel.js